module.exports = "<form *ngIf='cardSvg.hasUSPS' [formGroup]=\"uspsForm\">\n<mat-form-field style=\"width:100%\">\n  <textarea matInput placeholder=\"Product unique selling points\" rows=\"{{ numberOfLines }}\" formControlName=\"usps\" style=\"resize:none;\"></textarea>\n</mat-form-field>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/hq/cards/modify-card/update-usps/update-usps.component.html
// module id = ../../../../../src/app/hq/cards/modify-card/update-usps/update-usps.component.html
// module chunks = main